import axios from './index'

export default {
  // Şubenin mevcut kayıtlarından türetilir: { hasCustomer, hasAppointment, hasPaymentTool, hasSale,
  //   docplannerCustomerCount, docplannerAppointmentCount, marks: personelin karttaki işaretleri }
  getStatus() {
    return axios.get('/api/VegaCommon/GetGettingStarted')
      .then((response) => {
        return response.data;
      }).catch((error) => {
        return Promise.reject(error);
      });
  },
  // mark: adım anahtarı ya da 'Hidden'; yalnız 'Hidden' kaldırılabilir (on: false).
  setMark(mark, on = true) {
    return axios.post('/api/VegaCommon/SetGettingStartedMark', { mark, on })
      .catch((error) => {
        return Promise.reject(error);
      });
  }
}
